export const RECORD_ICONS = {
  Competitor: 'fa-solid fa-trophy',
  Epic: 'aha-icon aha-icon-epic-solid',
  Feature: 'fa-solid fa-grid-2 fa-fw',
  Goal: 'fa-solid fa-flag',
  Idea: 'fa-solid fa-lightbulb', // NOTE: the class get stored as just Idea in case of integration trigger
  'Ideas::Idea': 'fa-solid fa-lightbulb',
  'Ideas::IdeaTheme': 'fa-solid fa-circle-nodes',
  Initiative: 'fa-solid fa-sitemap',
  Iteration: 'fa-solid fa-input-pipe',
  MasterFeature: 'aha-icon aha-icon-epic-solid',
  MasterRelease: 'fa-solid fa-calendar-lines',
  Page: 'fa-solid fa-file-lines',
  Persona: 'fa-solid fa-address-card',
  Project: 'fa-regular fa-browser',
  Release: 'fa-solid fa-calendar-lines',
  ReleasePhase: 'fa-solid fa-timeline fa-fw',
  Requirement: 'fa-solid fa-list',
  StrategicImperative: 'fa-solid fa-flag',
  Task: 'aha-icon aha-icon-complete',
  'Discovery::Study': 'fa-regular fa-user-magnifying-glass',
  Study: 'fa-regular fa-user-magnifying-glass',
  'Discovery::Interview': 'fa-regular fa-comments',
  Interview: 'fa-regular fa-comments',
  KeyResult: 'fa-solid fa-arrow-trend-up fa-fw',
  'Polls::Poll': 'fa-solid fa-chart-simple',
};

// From app/assets/stylesheets/record_reference_pill.less
export const RECORD_ICON_DEFAULT_BACKGROUND_COLOR =
  'var(--theme-tertiary-text)';
export const RECORD_ICON_BACKGROUND_COLORS = {
  Epic: 'var(--aha-purple-300)',
  Feature: 'var(--aha-blue-500)',
  Goal: 'var(--aha-teal-600)',
  Idea: 'var(--aha-green-700)', // NOTE: the class get stored as just Idea in case of integration trigger
  'Ideas::Idea': 'var(--aha-green-700)',
  Initiative: 'var(--aha-pink-600)',
  MasterFeature: 'var(--aha-purple-300)',
  MasterRelease: 'var(--theme-secondary-text)',
  Release: 'var(--theme-secondary-text)',
  Requirement: 'var(--aha-orange-700)',
  StrategicImperative: 'var(--aha-teal-600)',
};

export const RECORD_ICON_COLORS = {
  StrategicImperative: 'var(--aha-topaz-800)',
  Initiative: 'var(--aha-topaz-800)',
  'Ideas::Idea': 'var(--aha-jade-800)',
  Idea: 'var(--aha-jade-800)',
  Task: 'var(--aha-gray-700)',
  Epic: 'var(--aha-purple-300)',
  Requirement: 'var(--aha-orange-700)',
};
